import * as React from 'react';
import styled from 'styled-components';
import Title from 'views/components/UI/Title';
import PageBody from 'views/components/UI/PageBody';
import { actions as messagesActions, IMessage } from 'reducer/messages';
import { adasActions } from 'reducer/adas';
import TopPanel from 'views/components/UI/TopPanel';
import Widgets from 'views/components/SpreadSheet/components/Widgets';
import moment from 'moment';
import {
  getList as getListRequest,
  deleteList as deleteListRequest,
  deleteListRA as deleteListRepApiRequest,
  saveElement as saveElementRequest,
  ITableRequest,
  IDeleteRequest,
  exportFile, exportFileNode,
} from 'api/handbooks/table';
import PaginationUI from 'views/components/UI/Pagination';

import ImportDialog from '../ImportDialog';
import DeleteDialog from '../DeleteDialog';

import {
  CommandBar,
  Modal,
  TextField,
  Stack,
  PrimaryButton,
  DefaultButton,
} from 'office-ui-fabric-react';

import SpreadSheet                               from 'views/components/SpreadSheet/index';
import { connect }                               from 'react-redux';
import { Dispatch }                              from 'redux';
import { actions as appActions }                 from 'reducer/app';
import TypesConfig                               from '../../configs';
import { checkCreate, checkDelete, checkUpdate } from 'utils/permissions';
import history                                   from 'utils/history';
import CustomCommandButtonWithTooltip            from 'views/components/UI/CustomCommandBarButtonWithTooltip';
import { getExportButton }                       from 'views/pages/PDM/components/ExportFileBlock/constants';
import _                                         from 'lodash';
import PageTabSelection                          from "../../../../../components/UI/PageTabSelection";
import TabSelectionButton                        from "../../../../../components/UI/PageTabSelection/TabSelectionButton/TabSelectionButton";
import {IRootState}                              from "../../../../../../reducer";
import { apiTypes }                              from 'shared/consts/handbooksApiTypes';

const Styles = {
  root: {
    paddingLeft: '0',
  },
};

interface IProps {
  toggleSpinner: (value: boolean) => any;
  addToStack?: (message: IMessage) => void;
  handbookType: string;
  isBlocked?: boolean;
  externalFilters?: any;
  onSelectedChange?: (rows: any[]) => void;
  hideActionButtons?: boolean;
  disableSelection?: boolean;
  onAcceptChanges?: () => void;
  getAdasIncidents?: () => void;
  defaultTemplate?: any;
  fullscreen:  boolean;
  isSidebarOpen: boolean;
}

interface IState {
  config: any;
  data: {
    list: any[];
    count: number;
  };
  connections: {
    [key: string]: any[];
  };
  sort: {
    field: string;
    direction: string;
  };
  filter: string | { [x: string]: any[]; }[];
  currentPage: number;
  multiAddElementsCount: number;
  showMultiModal: boolean;
  showImportModal: boolean;
  showDeleteModal: boolean;
  selectedData: {
    selectedRows: any[];
    currentSelectedRow: any;
  };
  selectedTab?: string;
  tabs?: {[key: string]: string};
  multipleConfig?: boolean;
  actionsQueue: Array<IAction>;
  processingAction: Promise<IAction> | null;
}

const InitialState: IState = {
  config: null as any,
  multiAddElementsCount: 1,
  showMultiModal: false,
  showImportModal: false,
  showDeleteModal: false,
  data: {
    list: [],
    count: 0,
  },
  sort: {
    field: '',
    direction: '',
  },
  filter: '',
  currentPage: 1,
  selectedData: {
    selectedRows: [],
    currentSelectedRow: null,
  },
  connections: {},
  actionsQueue: [],
  processingAction: null,
};

export type IMessageType = Pick<IMessage, 'type'>

export enum TriggerType {
  Update,
  Create,
  Delete,
}

export enum ConditionType {
  EmptyField,
}
export enum ActionType {
  ShowConfirm,
}


export interface ICondition {
  type: ConditionType
  fields: Array<string>
}

export interface IAction {
  type: ActionType
  payload: unknown
}

export interface IRule {
  trigger: TriggerType
  conditions: Array<ICondition>
  action: IAction
}

const FormWrapper = styled.div`
  padding: 16px 24px 0;
  max-width: 100%;
`;

class SingleTable extends React.Component<IProps, IState> {
  state = InitialState;

  async componentDidMount() {
    this.setupHandbook(this.props);
  }

  setupHandbook = (props: IProps) => {
    const config = TypesConfig[props.handbookType] as any;

    this.setState(
      {
        multipleConfig: !!config.multipleConfig,
        config:         {
          ...!config.multipleConfig ? config : config.tabs[this.state.selectedTab || config.defaultSelectedTab],
          fields: (config.multipleConfig
                   ? config.tabs[this.state.selectedTab || config.defaultSelectedTab].fields
                   : config.fields).map((field: any) => ({
            ...field,
            disabled: !checkUpdate(history.location.pathname) || field.disabled || field.readonly || !(config.canUpdate ?? true)
          })),
          canCreate: config.canCreate ?? true,
          canUpdate: config.canUpdate ?? true,
          canDelete: config.canDelete ?? true,
        },
        ...!config.multipleConfig ? { sort: config.defaultSort } : {
          sort: config.tabs[this.state.selectedTab ||
                            config.defaultSelectedTab].defaultSort
        },
        ...config.tabsTitles && !this.state.selectedTab && { selectedTab: config.defaultSelectedTab },
        ...config.tabsTitles && { tabs: config.tabsTitles }
      },
      this.reloadData
    );

    console.log(config);
    this.reloadConnections(config);
  };

  reloadConnections = (config: any) => {
    Object.keys(config.multipleConfig ? config.tabs[this.state.selectedTab || config.defaultSelectedTab].connections || {} : config.connections || {}).forEach(async (conName: string) => {
      const conConf = config.multipleConfig ? config.tabs[this.state.selectedTab || config.defaultSelectedTab].connections[conName] : config.connections[conName];
      this.props.toggleSpinner(true);
      const data = await getListRequest({...this.getConnectionFilter(conConf), type: conConf.apiType !== apiTypes.DEFAULT ? conConf.type ?? 'list' : undefined});
      const list = (data && data.list) || [];
      this.addOldValueToLoadedItems(list);
      this.setState({
        connections: { ...this.state.connections, ...{ [conName]: list } },
      });
      this.props.toggleSpinner(false);
    });
  };

  componentWillReceiveProps(newProps: IProps) {
    if (newProps.handbookType != this.props.handbookType) {
      this.setState(InitialState, () => this.setupHandbook(newProps));
    } else if (newProps.externalFilters != this.props.externalFilters) {
      this.reloadConnections(this.state.config);
    }
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.props.externalFilters !== prevProps.externalFilters) {
      this.reloadData();
    } else if (prevState.selectedTab !== this.state.selectedTab) {
      this.setState({ data: { list: [], count: 0 } }, () => this.setupHandbook(this.props));
    }
  }

  getConnectionFilter = (conConf: any): ITableRequest => {
    return {
      schema: conConf.schema,
      table: conConf.table,
      fields: conConf.apiType !== apiTypes.DEFAULT ? [...conConf.fields] : [...conConf.fields, conConf.index],
      customsql: conConf.customsql,
      sort: {
        field: conConf.fields.length > 0 ? conConf.fields[0] : conConf.index,
        direction: 'asc',
      },
      apiType: conConf.apiType,
    };
  };

  getFilter = (): ITableRequest => {
    const { config } = this.state;
    const obj = {
      schema: config.schema,
      table: config.table,
      fields: config.fields
        .filter((el: any) => !!el.name)
        .map((el: { name: string }) => el.name),
      sort: this.state.sort,
      limit: config.elemsOnPage,
      offset: (this.state.currentPage - 1) * (config.elemsOnPage),
      filters:
        this.props.externalFilters && this.props.externalFilters != ''
          ? `(${this.props.externalFilters}) ${
              this.state.filter || this.state.filter != ''
                ? ` AND (${this.state.filter})`
                : ''
            }`
          : this.state.filter,
      apiType: config.apiType,
    };

    return obj;
  };

  applyConversions = (dataArray: any, conversions: any) => {
    return dataArray.map((item: any) => {
      const convertedItem = { ...item };
      
      for (const key in item) {
        if (conversions?.[key]) {
          convertedItem[key] = conversions[key](item[key]);
        }
      }
      
      return convertedItem;
    });
  };

  reloadData = async () => {
    this.props.toggleSpinner(true);
    const res = await getListRequest({...this.getFilter(), type: this.state.config.apiType !== apiTypes.DEFAULT ? 'table' : undefined});
    this.addOldValueToLoadedItems(res.list || []);
    this.setState({
      data: {
        list: this.state.config.apiType !== apiTypes.DEFAULT ? this.applyConversions(res.list, this.state.config.convertFunctions) : res.list,
        count: res.count,
      },
      selectedData: {
        selectedRows: [],
        currentSelectedRow: null,
      },
    });
    this.props.toggleSpinner(false);
    this.props.onSelectedChange && this.props.onSelectedChange([]);
  };

  onSortChange = (field: string, direction: string) => {
    this.setState(
      {
        sort: { field, direction },
      },
      this.reloadData
    );
  };

  onFilterChange = (filter: string | { [x: string]: any[]; }[]) => {
    this.setState({ filter }, this.reloadData);
  };

  onPageChange = (pg: number): void => {
    this.setState(
      {
        currentPage: pg,
      },
      this.reloadData
    );
  };

  addElements = (elemCount: number): void => {
    const { data, config } = this.state;
    let list = (data && data.list) || [];
    for (let i = 0; i < elemCount; ++i) {
      list = [
        {
          ...config.newTemplate,
          ...(this.props.defaultTemplate || {}),
          ...{ __hasChanges: true },
          ...{ __newEmpty: true },
        },
        ...list,
      ];
    }
    data.list = list;
    this.forceUpdate();
  };

  onSelectedChange = (selectedRows: any[], currentSelectedRow: any): void => {
    if (!this.props.disableSelection) {
      this.setState({
        selectedData: {
          selectedRows,
          currentSelectedRow,
        },
      });
      this.props.onSelectedChange && this.props.onSelectedChange(selectedRows);
    }
  };

  isAnythingSelected = (): boolean => {
    const list = (this.state.data && this.state.data.list) || [];
    const { selectedRows, currentSelectedRow } = this.state.selectedData;
    if (currentSelectedRow && list.indexOf(currentSelectedRow) >= 0) {
      return true;
    }
    for (let i = 0; i < selectedRows.length; ++i) {
      if (list.indexOf(selectedRows[i]) >= 0) {
        return true;
      }
    }
    return false;
  };

  getIndexFieldName = (): string => {
    const { config } = this.state;
    for (let i = 0; i < config.fields.length; ++i) {
      if (config.fields[i].index) {
        return config.fields[i].name;
      }
    }
    return '';
  };

  getSelectedIds = () => {
    const { selectedRows, currentSelectedRow } = this.state.selectedData;
    const list = (this.state.data && this.state.data.list) || [];
    const indexField = this.getIndexFieldName();
    return list
      .filter(
        (row: any) =>
          row[indexField] !== null &&
          (row === currentSelectedRow || selectedRows.indexOf(row) >= 0)
      )
      .map((row: any) => row[indexField]);
  };

  removeSelected = async (): Promise<void> => {
    const { selectedRows, currentSelectedRow } = this.state.selectedData;
    const list = (this.state.data && this.state.data.list) || [];
    const indexField = this.getIndexFieldName();
    if (this.state.config.apiType !== apiTypes.DEFAULT) {
      await deleteListRepApiRequest(this.state.config, selectedRows );
      const data = await getListRequest({...this.getFilter(), type: this.state.config.apiType !== apiTypes.DEFAULT ? 'table' : undefined})
      this.addOldValueToLoadedItems(data.list || []);
      this.setState({
        data,
        currentPage: 1,
      });
    } else {
      const dbRemoveIds = list
      .filter(
        (row: any) =>
          row[indexField] !== null &&
          (row === currentSelectedRow || selectedRows.indexOf(row) >= 0)
      )
      .map((row: any) => row[indexField]);
      if (dbRemoveIds.length === 0) {
        const clearedList = list.filter((row: any) => {
          return !(
            (row[indexField] !== null && row === currentSelectedRow) ||
            selectedRows.indexOf(row) >= 0
          );
        });
        this.state.data.list = clearedList;
        this.forceUpdate();
      } else {
        // сохранить добавленные, но не сохраненные записи
        const newList = list.filter((row: any) => {
          return (
            !row[indexField] &&
            row !== currentSelectedRow &&
            selectedRows.indexOf(row) < 0
          );
        });
        try {
          const req = this.getFilter() as IDeleteRequest;
          req.offset = 0;
          req.field = indexField;
          req.indexes = dbRemoveIds.join(',');
          req.title = this.state.config.title;
          req.rows = selectedRows;
          this.props.toggleSpinner(true);
          let data = await deleteListRequest(req);
          let list = (data && data.list) || [];
            list = [...newList, ...list];
            data = { ...data, ...{ list } };
          this.setState({
            data,
            currentPage: 1,
          });
        } catch (e) {}
        this.props.toggleSpinner(false);
      }
    }
  };

  hasChanges = (): boolean => {
    const list = (this.state.data && this.state.data.list) || [];
    return list.some((el: any) => el['__hasChanges'] === true);
  };

  validateData = (): boolean => {
    const list = (this.state.data && this.state.data.list) || [];
    const { fields } = this.state.config;
    let result = true;
    list.forEach((row: any) => {
      const errors: { [key: string]: string } = {};
      fields.filter((field: any) => !field.hide).forEach((fl: any) => {
        if (row['__hasChanges']) {
          if (
            fl.required &&
            (row[fl.name] === null ||
              row[fl.name] === undefined ||
              row[fl.name] === '') &&
            (!fl.index ||
              row['__index__' + fl.name] === null ||
              row['__index__' + fl.name] === undefined ||
              row['__index__' + fl.name] === '')
          ) {
            errors[fl.name] = 'Обязательное поле.';
          } else if (fl.validate && !fl.validate(row[fl.name], row)) {
            if (fl.required || (row[fl.name] && row[fl.name] !== ''))
              errors[fl.name] = fl.validateError;
          }
        }
      });
      if (Object.keys(errors).length > 0) {
        row['__errors'] = errors;
        result = false;
      }
    });
    return result;
  };

  acceptChanges = async (): Promise<void> => {
    if (!this.validateData()) {
      this.props.addToStack &&
        this.props.addToStack({
          key: 'validate-error',
          messages: ['Проверьте заполнение полей.'],
        });
      this.forceUpdate();
      return;
    }

    const list = (this.state.data && this.state.data.list) || [];

    await this.getAndCheckRulesByTrigger(TriggerType.Update, this.state.config.rules || [], list);

    this.props.toggleSpinner(true);

    let newList = [];
    let hasErrors = false;

    list.forEach((row) => {
      delete row['__newEmpty'];
    })

    if (this.state.config.apiType !== apiTypes.DEFAULT) {
      const editedRows = list.filter(row => row['__hasChanges']);

      try {
        newList = await saveElementRequest(this.state.config, editedRows);
        if (newList?.createError?.length || newList?.updateError?.length) {
          hasErrors = true;
        } else {
          hasErrors = false;
        }
      } catch (error) {
        hasErrors = true;
      }
    } else {
      for (let i = 0; i < list.length; ++i) {
        let row = list[i];
  
        for (const rowProperty in row) {
          const _tmpRowProperty = row[rowProperty] + '';
          if(_tmpRowProperty.includes('meta-disable')){
            row[rowProperty] = Boolean(row[rowProperty].replace('meta-disable', '').replace('|', ''));
          }
        }
  
        if (row['__hasChanges']) {
          const newRow = await saveElementRequest(this.state.config, row);
          if (newRow && newRow.row) {
            newList.push(newRow.row);
          } else {
            hasErrors = true;
            row['__errors'] = { [this.getIndexFieldName()]: 'Ошибка сохранения' };
            newList.push(row);
          }
        } else {
          newList.push(row);
        }
      }
    }
    
    this.props.toggleSpinner(false);
    if (!hasErrors) {
      const {onAcceptChanges, getAdasIncidents} = this.props;
      const {config: {updateInStore}} = this.state;
      this.reloadData();
      onAcceptChanges && onAcceptChanges();
      getAdasIncidents && updateInStore && getAdasIncidents();
    } else {
      const data = { ...this.state.data };
      if (this.state.config.apiType !== apiTypes.DEFAULT) {
        const errorRows = list.filter(row => row['__hasChanges'])
        const indexField = this.state.config.fields.find((field: any) => field.index);
        const keyField = indexField?.name || this.state.config.keyField || 'id';
        const updateErrorRows = errorRows.filter(row => row[keyField]);
        const createErrorRows = errorRows.filter(row => !row[keyField]);

        newList?.createError?.forEach((error: any) => {
          if (error.error === 500) {
            createErrorRows[error.index]['__errors'] = { id: 'Ошибка сохранения' }
          } else {
            createErrorRows[error.index]['__errors'] = { [error.field]: error.error === 400 ? 'Значение должно быть уникальным' : 'Неверный формат' }
          }
        })

        newList?.updateError?.forEach((error: any) => {
          if (error.error === 500) {
            updateErrorRows[error.index]['__errors'] = { id: 'Ошибка сохранения' }
          } else {
            updateErrorRows[error.index]['__errors'] = { [error.field]: error.error === 400 ? 'Значение должно быть уникальным' : 'Неверный формат' }
          }
        })

        data.list = list.map((row) => {
          const errRow = errorRows.find((errRow) => errRow[keyField] === row[keyField]);
          if (errRow) {
            return errRow;
          }
          return row;
        });
      } else {
        data.list = newList;
      }
      this.setState({ data });
    }
  };

  downloadErrorsFile = (errorsStr: string) => {
    const link = document.createElement('a');
    const blob = new Blob([errorsStr], {type: 'text/plain'});

    link.href = window.URL.createObjectURL(blob);
    const fileDate = moment().format('DD.MM.YYYY HH-mm')
    link.download = `Ошибки импорта нарядов ${fileDate}.txt`;
    link.click();

    window.URL.revokeObjectURL(link.href);
  };

  addOldValueToLoadedItems = (list: any[]): void => {
    list.forEach((item) => {
      item['__oldValue'] = _.cloneDeep(item);
    });
  };

  onSuccessImport = (
    errorData?: {errorsStr: string, errorMessage: [string], messageType: IMessageType}
  ) => {
    const { addToStack } = this.props;
    addToStack && addToStack({
      key: errorData?.errorsStr ? 'import-error' : 'import-success',
      messages: errorData?.errorMessage ? [errorData.errorMessage] : ['Данные успешно импортированы.'],
      type: errorData?.messageType ? errorData.messageType : 'success'
    } as IMessage);
    errorData?.errorsStr && this.downloadErrorsFile(errorData.errorsStr);
    this.setState({ showImportModal: false });
    this.reloadData();
  };

  onWidgetStateChange = () => {
    this.forceUpdate();
  };

  onWidgetRefresh = () => {
    this.reloadConnections(this.state.config);
    this.reloadData();
  };

  onExport = async (fileType: string) => {
    try {
      let response;

      const requestBody = this.getFilter();

      if (this.state.config.apiType !== apiTypes.DEFAULT) {
        response = await exportFile({...requestBody, fileType, limit: 0})
      } else {
        response = await exportFileNode(fileType, {
          config: this.state.config,
          filters: requestBody.filters,
          sort: requestBody.sort,
          offset: requestBody.offset,
        });
      }

      if (response) {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(response.data);
        a.download = response.headers && response.headers['x-report-filename']
                     ? response.headers['x-report-filename']
                     : `exported-handbook.${fileType}`;
        a.click();
      }
    } catch (err) {
      this.props.addToStack && this.props.addToStack({
        key: 'export',
        type: 'error',
        messages: ['Получение файла невозможно']
      })
    }
  }

  checkRuleConditions = (rule: IRule, row: any): boolean => {
    return rule.conditions.every((condition) => {
      switch (condition.type) {
        case ConditionType.EmptyField:
          return condition.fields.every((fieldName) => !row[fieldName]);
      }
      return true;
    });
  }


  getRuleActionPromise = (action: IAction, row: any): Promise<IAction> => {
    switch (action.type) {
      case ActionType.ShowConfirm:
        return new Promise((res, rej) => {
          res(action);
        });
    }
  }

  processRuleActions = (row: any, res: any, rej: any) => {
    if (this.state.processingAction) {
      return;
    }

    const actionForProcess = this.state.actionsQueue.shift();

    if (actionForProcess) {
      const actionPromise = this.getRuleActionPromise(actionForProcess, row);

      this.setState(
        {
          processingAction: actionPromise,
        },
        () =>  actionPromise
          .finally(() => {
            this.setState(
              {
                processingAction: null,
              },
              () => this.processRuleActions(row, res, rej),
            )
          }),
      )
    } else {
      res(null);
    }
  }

  checkRules = (rules: IRule[], row: any, res: any, rej: any): boolean => {
    const conditionsPassedRules =
            rules.filter((rule) => this.checkRuleConditions(rule, row));

    if (conditionsPassedRules.length) {
      conditionsPassedRules.forEach((rule) => {
        this.state.actionsQueue.push(rule.action);
        this.processRuleActions(row, res, rej);
      });

      return false;
    }
    return true;
  }

  getAndCheckRulesByTrigger = (trigger: TriggerType, rules: IRule[], rows: any[]) => {
    const rulesByTrigger = rules.filter((rule) => rule.trigger === trigger);

    return new Promise((res, rej) => {
      const thereIsNoAction = rows.every((row) => {
        switch (trigger) {
          case TriggerType.Create:
          case TriggerType.Update:
          case TriggerType.Delete:
            return this.checkRules(rulesByTrigger, row, res, rej);
        }
        return true;
      });

      if (thereIsNoAction) {
        res(null);
      }
    });
  }

  render() {
    const {
      config,
      data,
      sort,
      currentPage,
      multiAddElementsCount,
      showImportModal,
      showDeleteModal,
      selectedTab,
      tabs,
      multipleConfig
    } = this.state;
    if (!config) return <div/>;
    const totalPage = Math.ceil(data?.count / config.elemsOnPage);
    
    return (
      <div>
        {
          multipleConfig &&
          <PageTabSelection isSideBarOpen={this.props.isSidebarOpen} fullscreen={this.props.fullscreen}>
            {
              tabs &&
              Object.entries(tabs)
                .map(([key, value]) =>
                  <TabSelectionButton
                    key={key}
                    handleClick={() => this.setState({selectedTab: key})}
                    isSelected={selectedTab === key}
                    title={value as string}
                  />)
            }
          </PageTabSelection>
        }
        <TopPanel
          style={{
            height: '38px',
            overflow: 'hidden',
          }}
        >
          <CommandBar
            items={
              this.props.hideActionButtons
                ? []
                : [
                    ...[
                      ...(!config.canUpdate
                          ? []
                          : [
                          {
                            key:       'acceptEditing',
                            name:      'Применить изменения',
                            iconProps: { iconName: 'Accept' },
                            disabled:  !this.hasChanges(),
                            onClick:   () => {
                              this.acceptChanges();
                            },
                          },
                        ]),
                      ...(!config.canCreate
                          ? []
                          : [
                          {
                            key:       'addElement',
                            name:      'Добавить запись',
                            iconProps: { iconName: 'Add' },
                            onClick:   () => {
                              this.addElements(1);
                            },
                            disabled:  !checkCreate(history.location.pathname) || !config.canCreate,
                            title:     !checkCreate(history.location.pathname) ? 'Недостаточно прав доступа' : undefined,
                          },
                          {
                            key:       'addElementList',
                            name:      'Добавить несколько',
                            iconProps: { iconName: 'CPlusPlusLanguage' },
                            onClick:   () => {
                              this.setState({ showMultiModal: true });
                            },
                            disabled:  !checkCreate(history.location.pathname) || !config.canCreate,
                            title:     !checkCreate(history.location.pathname) ? 'Недостаточно прав доступа' : undefined,
                          },
                        ]),
                      ...(!config.canUpdate || !config.canDelete
                          ? []
                          : [
                          {
                            key:         'importElements',
                            name:        'Удалить записи',
                            iconProps:   { iconName: 'Delete' },
                            disabled:    !this.isAnythingSelected() || !checkDelete(history.location.pathname) || !config.canUpdate,
                            ['data-qa']: 'removeEntriesBtn',
                            onClick:     () => {
                              const selList = this.getSelectedIds();
                              if (selList && selList.length > 0) {
                                this.setState({ showDeleteModal: true });
                              } else {
                                this.removeSelected();
                              }
                            },
                            title:       !checkDelete(history.location.pathname) ? 'Недостаточно прав доступа' : undefined,
                          },
                        ]),
                      ...(config.hideImport || !config.canCreate
                          ? []
                          : [
                          {
                            key:         'removeElements',
                            name:        'Импортировать записи',
                            iconProps:   { iconName: 'ImportAllMirrored' },
                            ['data-qa']: 'importEntriesBtn',
                            onClick:     () => {
                              this.setState({ showImportModal: true });
                            },
                            disabled:    !this.state.config.import || !checkCreate(history.location.pathname) || !config.canCreate,
                            title:       !checkCreate(history.location.pathname) ? 'Недостаточно прав доступа' : undefined,
                          },
                        ]),
                    ],
                  ...(config.hideExport
                        ? []
                        : [getExportButton(
                              false,
                              (_, item) => {
                                if (item && item.key) {
                                  this.onExport(item.key)
                                }
                              },
                              {
                                'xlsx': {
                                  iconName: 'ExcelLogoInverse',
                                  text: 'Экспортировать таблицу в Excel',
                                },
                                'csv': {
                                  iconName: 'TableGroup',
                                  text: 'Экспортировать таблицу в CSV',
                                }
                              }
                            )]),
                    ...(this.state.config.widgets
                      ? this.state.config.widgets.map((key: string) => {
                          Widgets[key].onStateChange = this.onWidgetStateChange;
                          Widgets[key].onWidgetRefresh = this.onWidgetRefresh;
                          return Widgets[key];
                        })
                      : []),
                  ]
            }
            farItems={[
              {
                key: 'filtersReset',
                name: 'Сбросить фильтры',
                iconProps: { iconName: 'ClearFilter' },
                onClick: () => {
                  this.setState(InitialState, () =>
                    this.setupHandbook(this.props)
                  );
                },
              },
            ]}
            styles={Styles}
            buttonAs={CustomCommandButtonWithTooltip}
          />
        </TopPanel>
        {showImportModal && (
          <ImportDialog
            handleClose={() => this.setState({ showImportModal: false })}
            config={this.state.config}
            onSuccess={this.onSuccessImport}
          />
        )}
        <React.Fragment>
          {this.state.config.widgets
            ? this.state.config.widgets.map((key: string) =>
                Widgets[key].component()
              )
            : undefined}
        </React.Fragment>
        <Modal isOpen={this.state.showMultiModal}>
          <FormWrapper>
            <TextField
              label="Укажите количество строк"
              value={multiAddElementsCount.toString()}
              onChange={(e) => {
                let num = parseInt((e.target as any).value.replace(/\D/gi, ''));
                if (num < 1) {
                  num = 1;
                }
                if (num > 100) {
                  num = 100;
                }
                this.setState({ multiAddElementsCount: num });
              }}
            />
            <Stack
              horizontal
              horizontalAlign={'end'}
              tokens={{ childrenGap: 10 }}
              styles={{ root: { padding: '10px 0' } }}
            >
              <PrimaryButton
                text="Применить"
                disabled={
                  multiAddElementsCount < 1 || multiAddElementsCount > 100
                }
                onClick={() => {
                  this.addElements(multiAddElementsCount);
                  this.setState({ showMultiModal: false });
                }}
              />
              <DefaultButton
                text="Отмена"
                onClick={() => this.setState({ showMultiModal: false })}
              />
            </Stack>
          </FormWrapper>
        </Modal>
        <Modal isOpen={false}>
          <FormWrapper>
            <TextField
              label={'Предупреждение'}
              value={''}
              onChange={(e) => {}}
            />
            <Stack
              horizontal
              horizontalAlign={'end'}
              tokens={{ childrenGap: 10 }}
              styles={{ root: { padding: '10px 0' } }}
            >
              <PrimaryButton
                text="Применить"
                disabled={false}
                onClick={() => {}}
              />
              <DefaultButton
                text="Отмена"
                onClick={() => {}}
              />
            </Stack>
          </FormWrapper>
        </Modal>
        {showDeleteModal && (
          <DeleteDialog
            ids={this.getSelectedIds()}
            onCancel={() => this.setState({ showDeleteModal: false })}
            onSuccess={() => {
              this.removeSelected();
              this.setState({ showDeleteModal: false });
            }}
            apiType={this.state.config.apiType}
            confirmationCode={Math.floor(Math.random() * 900) + 100}
          />
        )}
        <PageBody withoutTopPanel={false}>
          {!this.props.isBlocked && <Title>{config.title}</Title>}
          <SpreadSheet
            config={config}
            multipleConfig={multipleConfig}
            data={data}
            sort={sort}
            onSortChange={this.onSortChange}
            onFilterChange={this.onFilterChange}
            onSelectedChange={this.onSelectedChange}
            connections={this.state.connections}
            externalFilters={this.props.externalFilters}
            disableSelection={this.props.disableSelection}
          />
          {totalPage > 0 && (
            <PaginationUI
              totalPage={totalPage}
              handlePagination={this.onPageChange}
              currentPage={currentPage}
            />
          )}
        </PageBody>
      </div>
    );
  }
}

const mapActionToProps = (dispatch: Dispatch) => {
  return {
    toggleSpinner: (value: boolean) =>
      dispatch(appActions.toggleSpinner({ value: value })),
    addToStack: (message: IMessage) =>
      dispatch(messagesActions.addToStack(message)),
    getAdasIncidents: () => dispatch(adasActions.getIncidentsTypes()),
  };
};

const mapStateToProps = ({ app }: IRootState) => ({
  fullscreen: app.fullscreen,
  isSidebarOpen: app.isSideBarOpen
});

export default connect(mapStateToProps, mapActionToProps)(SingleTable);
